import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ConstantsService } from './constants.service';
import { ActionItemsTemplateDetails, PostTemplateAssignUnassignMyEmployer } from '@core/models/action-item-templates/action-item-template-details.model';
import { ACTIONITEM_TEMPLATE_DETAILS, EDIT_ACTIONITEMS_DIALOG, EDIT_ACTIONITEMS_TEMPLATE_INFO_DIALOG } from '@core/mocks/action-item-templates/action-item-template-details.mock';
import { EditActionItemsDialog, PostTemplateActionItems } from '@core/models/action-item-templates/edit-action-items-dialog.model';
import { ActionItemsTemplatesDashboard, NewActionItemPost, NewActionItemsTemplatePost } from '@core/models/action-item-templates/action-item-templates-dashboard.model';
import { ActionItemsTemplateInfoPost, EditActionItemsTemplateInfoDialog, EditActionItemsTemplateInfoDialogLeaveTypes } from '@core/models/action-item-templates/edit-action-item-template-info-dialog.model';
import { ActionItemDetails } from '@core/models/action-item-templates/action-item-details.model';
import { ACTIONITEM_DETAILS, ADD_EDIT_ACTIONITEM_NOTIF_DIALOG } from '@core/mocks/action-item-templates/action-item-details.mock';
import { ActionItemInfoPost, EditActionItemInfoDialog } from '@core/models/action-item-templates/edit-action-item-info-dialog.model';
import { AddEditActionItemNotificationDialog, PostActionNotification } from '@core/models/action-item-templates/add-edit-action-item-notification.model';
import { AssignedEmployersDialog } from '@core/models/shared/assigned-employers-dialog.model';
import { ActionItemAssignedEmployersPost, ActionItemsTemplateAssignedEmployersPost } from '@core/models/action-item-templates/assigned-employers-post-model';

@Injectable({
  providedIn: 'root'
})
export class ActionItemsTemplatesService { 
  private apiUrl: string;

  constructor(private http: HttpClient, private constants: ConstantsService) {
    this.apiUrl = this.constants.AIT_API;
   }

  public getActionItemsTemplatesDashboard(): Observable<ActionItemsTemplatesDashboard> {
    return this.http.get<ActionItemsTemplatesDashboard>(`${this.apiUrl}/getActionItemsTemplatesDashboard`);
    //return of(ACTIONITEM_TEMPLATES).pipe(delay(1000));
  }

  public getTemplateDetails(templateId: number): Observable<ActionItemsTemplateDetails> {
    return this.http.get<ActionItemsTemplateDetails>(`${this.apiUrl}/getTemplateDetails/${templateId}`);
    //return of(ACTIONITEM_TEMPLATE_DETAILS).pipe(delay(1000));
  }

  public getActionItemDetails(actionItemId: number): Observable<ActionItemDetails> {
    return this.http.get<ActionItemDetails>(`${this.apiUrl}/getActionItemDetails/${actionItemId}`);
    //return of(ACTIONITEM_DETAILS).pipe(delay(1000));
  }

  public getEditActionItemsTemplateInfoDialog(templateId: number): Observable<EditActionItemsTemplateInfoDialog> {
    return this.http.get<EditActionItemsTemplateInfoDialog>(`${this.apiUrl}/getEditActionItemsTemplateInfoDialog/${templateId}`);
    //return of(EDIT_ACTIONITEMS_TEMPLATE_INFO_DIALOG).pipe(delay(1000));
  }

  public getActionItemsTemplateLeaveTypes(ownerEmployerId): Observable<EditActionItemsTemplateInfoDialogLeaveTypes> {
    return this.http.get<EditActionItemsTemplateInfoDialogLeaveTypes>(`${this.apiUrl}/getActionItemsTemplateLeaveTypes/${ownerEmployerId}`);
  }

  public getEditActionItemInfoDialog(actionItemId: number): Observable<EditActionItemInfoDialog> {
    return this.http.get<EditActionItemInfoDialog>(`${this.apiUrl}/getEditActionItemInfoDialog/${actionItemId}`);
    //return of(EDIT_ACTIONITEMS_TEMPLATE_INFO_DIALOG).pipe(delay(1000));
  }

  public getAddEditActionItemNotificationDialog(actionItemId: number): Observable<AddEditActionItemNotificationDialog> {
    return this.http.get<AddEditActionItemNotificationDialog>(`${this.apiUrl}/getAddEditActionItemNotificationDialog/${actionItemId}`);
    //return of(ADD_EDIT_ACTIONITEM_NOTIF_DIALOG).pipe(delay(1000));
  }

  public getEditActionItemsDialog(templateId: number): Observable<EditActionItemsDialog> {
    return this.http.get<EditActionItemsDialog>(`${this.apiUrl}/getEditActionItemsDialog/${templateId}`);
    //return of(EDIT_ACTIONITEMS_DIALOG).pipe(delay(1000));
  }

  public getEditTemplateAssignedEmployersDialog(templateId: number): Observable<AssignedEmployersDialog> {
    return this.http.get<AssignedEmployersDialog>(`${this.apiUrl}/getEditTemplateAssignedEmployersDialog/${templateId}`);
  }

  public getEditActionItemAssignedEmployersDialog(actionItemId: number): Observable<AssignedEmployersDialog> {
    return this.http.get<AssignedEmployersDialog>(`${this.apiUrl}/getEditActionItemAssignedEmployersDialog/${actionItemId}`);
  }

  public postNewTemplate(dto: NewActionItemsTemplatePost): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/postNewTemplate`, dto);
    //return of(1).pipe(delay(1000));
  }

  public postNewActionItem(dto: NewActionItemPost): Observable<number> {
    return this.http.post<number>(`${this.apiUrl}/postNewActionItem`, dto);
    //return of(1).pipe(delay(1000));
  }

  public postActionItemsTemplateDelete(dto: {actionItemsTemplateId: number}): Observable<ActionItemsTemplatesDashboard> {
    return this.http.post<ActionItemsTemplatesDashboard>(`${this.apiUrl}/postActionItemsTemplateDelete`, dto);
    //return of(ACTIONITEM_TEMPLATES).pipe(delay(1000));
  }

  public postActionItemDelete(dto: {actionItemId: number}): Observable<ActionItemsTemplatesDashboard> {
    return this.http.post<ActionItemsTemplatesDashboard>(`${this.apiUrl}/postActionItemDelete`, dto);
    //return of(ACTIONITEM_TEMPLATES).pipe(delay(1000));
  }

  public postActionItemsTemplateInfo(dto: ActionItemsTemplateInfoPost): Observable<ActionItemsTemplateDetails> {
    return this.http.post<ActionItemsTemplateDetails>(`${this.apiUrl}/postActionItemsTemplateInfo`, dto);
    //return of(ACTIONITEM_TEMPLATE_DETAILS).pipe(delay(1000));
  }

  public postActionItemInfo(dto: ActionItemInfoPost): Observable<ActionItemDetails> {
    return this.http.post<ActionItemDetails>(`${this.apiUrl}/postActionItemInfo`, dto);
    //return of(ACTIONITEM_DETAILS).pipe(delay(1000));
  }

  public postNewActionItemNotification(dto: PostActionNotification): Observable<ActionItemDetails> {
    return this.http.post<ActionItemDetails>(`${this.apiUrl}/postNewActionItemNotification`, dto);
    //return of(ACTIONITEM_DETAILS).pipe(delay(1000));
  }

  public postEditActionItemNotification(dto: PostActionNotification): Observable<ActionItemDetails> {
    return this.http.post<ActionItemDetails>(`${this.apiUrl}/postEditActionItemNotification`, dto);
    //return of(ACTIONITEM_DETAILS).pipe(delay(1000));
  }

  public postActionItemNotificationDelete(dto: {actionItemNotificationId: number}): Observable<ActionItemDetails> {
    return this.http.post<ActionItemDetails>(`${this.apiUrl}/postActionItemNotificationDelete`, dto);
    //return of(ACTIONITEM_DETAILS).pipe(delay(1000));
  }

  public postTemplateActionItems(dto: PostTemplateActionItems): Observable<ActionItemsTemplateDetails> {
    return this.http.post<ActionItemsTemplateDetails>(`${this.apiUrl}/postTemplateActionItems`, dto);
    //return of(ACTIONITEM_TEMPLATE_DETAILS).pipe(delay(1000));
  }

  public postHideActionItem(dto: {actionItemId: number}): Observable<ActionItemsTemplatesDashboard> {
    return this.http.post<ActionItemsTemplatesDashboard>(`${this.apiUrl}/postHideActionItem`, dto);
    //return of(ACTIONITEM_TEMPLATES).pipe(delay(1000));
  }

  public postUnhideActionItem(dto: {actionItemId: number}): Observable<ActionItemsTemplatesDashboard> {
    return this.http.post<ActionItemsTemplatesDashboard>(`${this.apiUrl}/postUnhideActionItem`, dto);
    //return of(ACTIONITEM_TEMPLATES).pipe(delay(1000));
  }

  public postActionItemsTemplateAssignedEmployers(dto: ActionItemsTemplateAssignedEmployersPost): Observable<ActionItemsTemplateDetails> {
    return this.http.post<ActionItemsTemplateDetails>(`${this.apiUrl}/postActionItemsTemplateAssignedEmployers`, dto)
  }

  public postActionItemAssignedEmployers(dto: ActionItemAssignedEmployersPost): Observable<ActionItemDetails> {
    return this.http.post<ActionItemDetails>(`${this.apiUrl}/postActionItemAssignedEmployers`, dto)
  }

  public postTemplateAssignMyEmployer(dto: PostTemplateAssignUnassignMyEmployer): Observable<ActionItemsTemplateDetails | ActionItemsTemplatesDashboard> { 
    return this.http.post<ActionItemsTemplateDetails>(`${this.apiUrl}/postTemplateAssignMyEmployer`, dto);
  }

  public postTemplateUnassignMyEmployer(dto: PostTemplateAssignUnassignMyEmployer): Observable<ActionItemsTemplateDetails | ActionItemsTemplatesDashboard> { 
    return this.http.post<ActionItemsTemplateDetails>(`${this.apiUrl}/postTemplateUnassignMyEmployer`, dto);
  }

  public postActionItemAssignMyEmployer(dto: {actionItemId: number}): Observable<ActionItemDetails> { 
    return this.http.post<ActionItemDetails>(`${this.apiUrl}/postActionItemAssignMyEmployer`, dto);
  }

  public postActionItemUnassignMyEmployer(dto: {actionItemId: number}): Observable<ActionItemDetails> { 
    return this.http.post<ActionItemDetails>(`${this.apiUrl}/postActionItemUnassignMyEmployer`, dto);
  }
}